import ProgramSignupPage from './ProgramSignup/ProgramSignupPage'
import { HeroSection } from '../components/HeroSection/HeroSectionSignUp'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { useUrlSearchParam } from '@/hooks'
import { useIsAvaBasePath } from '@/app/hooks/ava/useAvaVerification'

const useRedirectToWhiteLabelIfNeeded = () => {
  const { utility } = useParams<{ utility?: string }>()
  if (utility !== undefined) return
  const listing = useUrlSearchParam('listing')
  if (!listing) return
  const location = useLocation()
  const history = useHistory()
  history.replace(`/${listing}${location.pathname}`)
}

type SignUpProps = {
  initialMode?: 'signup' | 'login' | 'impersonate'
}

export default function SignUp({ initialMode }: SignUpProps = {}) {
  useRedirectToWhiteLabelIfNeeded()
  const location = useLocation()
  const { programId } = useParams<{ programId?: string }>()
  const programIdNum =
    programId != null && programId !== '' ? parseInt(programId, 10) : null
  const isValidProgramId =
    programIdNum != null && !Number.isNaN(programIdNum) && programIdNum > 0

  // Ava has a custom signup page that predates the white-label ProgramSignupPage.
  // Keep serving their custom page at /ava/signup rather than the new generic one.
  // useBasePath() returns the first path segment, so this is true only for
  // /ava/signup (not /login/ava, where the base path is "login").
  const isAvaSignup = useIsAvaBasePath()

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_CAPTCHA_SITE_KEY ?? ''}
    >
      {isAvaSignup ? (
        <HeroSection programId={isValidProgramId ? programIdNum : null} />
      ) : (
        <ProgramSignupPage
          key={location.pathname}
          programId={isValidProgramId ? programIdNum : null}
          initialMode={initialMode}
        />
      )}
    </GoogleReCaptchaProvider>
  )
}
